<form class="flex grow flex-col gap-4" [formGroup]="formGroup">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Comparison</mat-label>
    <mat-select formControlName="comparison" required>
      @for (comparison of comparisons; track comparison) {
        <mat-option [value]="comparison.value">
          {{ comparison.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="flex grow" subscriptSizing="dynamic">
    <mat-label>
      {{ propertyLabel() }}
      {{
        formGroup.value.comparison | map: getComparisonLabel : this | lowercase
      }}
    </mat-label>
    <mat-select
      formControlName="values"
      [compareWith]="compareWithFn"
      [multiple]="true"
    >
      <mat-option>
        <ngx-mat-select-search
          placeholderLabel="Search for {{ propertyLabel() }}"
          noEntriesFoundLabel="No matching {{ propertyLabel() }} found"
          [formControl]="searchCtrl"
          [showToggleAllCheckbox]="true"
          [toggleAllCheckboxTooltipMessage]="'Select All / Unselect All'"
          [toggleAllCheckboxTooltipPosition]="'above'"
          (toggleAll)="toggleSelectAll($event)"
        />
      </mat-option>

      @for (option of filteredOptions(); track option.group) {
        @if (!option.group) {
          @for (item of option.items; track item.value) {
            <mat-option [value]="item">{{ item.label }}</mat-option>
          }
        } @else {
          <mat-optgroup [label]="option.group">
            @for (item of option.items; track item.value) {
              <mat-option [value]="item">{{ item.label }}</mat-option>
            }
          </mat-optgroup>
        }
      }
    </mat-select>
  </mat-form-field>
</form>
